import React from 'react';
import ReactDOM from 'react-dom';

import CustomHtmlSlot from '@/common/components/CustomHtmlSlot';

const custom_message_slots = [
    'kiosk-attract-screen',
    'logo-above',
    'logo-below',
    'menu-above',
    'menu-below',
    'order-above',
    'order-slot-1',
    'order-slot-2',
    'order-slot-3',
    'order-slot-4',
    'order-below',
    'confirmation-above',
    'confirmation-middle',
    'confirmation-below',
    'mobile-customer-profile-above',
    'mobile-customer-profile-below',
    'mobile-customer-register-above',
    'mobile-customer-register-below',
    'mobile-customer-login-above',
    'mobile-customer-login-below',
    'instore-landing-screen',
];

const renderSlotsState = {};
// eslint-disable-next-line import/prefer-default-export
export const renderSlot = slot => {
    if (slot in renderSlotsState) {
        ReactDOM.unmountComponentAtNode(renderSlotsState[slot]);
        delete renderSlotsState[slot];
    }
    const slot_element = document.querySelector(
        `[data-custom-html-slot="${slot}"]`
    );
    if (slot_element) {
        ReactDOM.render(<CustomHtmlSlot slot={slot} />, slot_element);
        renderSlotsState[slot] = slot_element;
    }
};

Mobi2Go.Order.onReady(() => {
    custom_message_slots.forEach(custom_message_slot => {
        if (typeof custom_message_slot === 'object') {
            const handler = () => {
                custom_message_slot.slots.forEach(slot => renderSlot(slot));
            };
            let target = window;
            custom_message_slot.target.split('.').forEach(targetFragment => {
                target = target[targetFragment];
            });
            if (target) {
                target.bind(custom_message_slot.event, handler);
                handler();
            }
        } else {
            renderSlot(custom_message_slot);
        }
    });
});
